import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams } from 'react-router';
import { setData } from '../../../features/ecBindingSlice';
import Button from '../../shared/Button';
import Header from './Header';
import PageTitle from './PageTitle';
import TermsTitle from './TermsTitle';
import TermsDescription from './TermsDescription';
import TermsBtnBackgroundColor from './TermsBtnBackgroundColor';
import Preview from '../../shared/TermsPage';

const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    setting: {},
    preview: {
      width: 360,
      paddingTop: 89,
      height: 729,
    },
  },
  {
    name: 'Step2Container',
  },
);

const Step2Container = ({ provider }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const { data, isSaved } = useSelector(store => store.ecBinding);
  const [isCheck, setIsCheck] = useState(false);
  const { policy } = data || {};
  const {
    pageTitle,
    title: termsTitle,
    content: termsDescription,
    btnBgColor: termsBtnBackgroundColor,
  } = policy || {};

  const handlePageTitleChange = value => {
    dispatch(
      setData({
        policy: {
          ...policy,
          pageTitle: value,
        },
      }),
    );
  };

  const handleTermsTitleChange = value => {
    dispatch(
      setData({
        policy: {
          ...policy,
          title: value,
        },
      }),
    );
  };

  const handleTermsDescriptionChange = value => {
    dispatch(
      setData({
        policy: {
          ...policy,
          content: value,
        },
      }),
    );
  };

  const handleTermsBtnBackgroundColorChange = value => {
    dispatch(
      setData({
        policy: {
          ...policy,
          btnBgColor: value,
        },
      }),
    );
  };

  const handleNext = () => {
    history.push(`/${provider}/${orgId}/step3`);
  };

  return (
    <div className={classes.root}>
      <div className={classes.setting}>
        <Header />
        <PageTitle
          pageTitle={pageTitle}
          onChange={handlePageTitleChange}
          isSaved={isSaved}
        />
        <TermsTitle
          termsTitle={termsTitle}
          onTermsTitleChange={handleTermsTitleChange}
          isSaved={isSaved}
        />
        <TermsDescription
          termsDescription={termsDescription}
          onTermsDescriptionChange={handleTermsDescriptionChange}
          isSaved={isSaved}
        />
        <TermsBtnBackgroundColor
          termsBtnBackgroundColor={termsBtnBackgroundColor}
          onColorChange={handleTermsBtnBackgroundColorChange}
        />
        <Button topic="primaryGreen" onClick={handleNext}>
          {t('next')}
        </Button>
      </div>
      <div className={classes.preview}>
        <Preview
          data={data}
          isCheck={isCheck}
          setIsCheck={value => {
            setIsCheck(value);
          }}
        />
      </div>
    </div>
  );
};

export default Step2Container;
